export enum DeliveriesFilterColumns {
  CHECKBOX = 'check',
}
